import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { environment } from '@environments/environment';

@Component({
    selector: 'app-dialog-confirm-delete',
    templateUrl: './dialog-confirm-delete.component.html',
    styles: [],
    standalone: false
})
export class DialogConfirmDeleteComponent implements OnInit {
  public isMobile: boolean;
  constructor(
    public dialogRef: MatDialogRef<DialogConfirmDeleteComponent>,
    @Inject(MAT_DIALOG_DATA) public data
  ) {
    this.isMobile = environment.platform === 'mobile';
  }

  ngOnInit() {
  }

  onNoClick(): void {
    this.dialogRef.close();
  }
}
